export type StatusLevel = 'critical' | 'caution' | 'warning' | 'success' | 'info' | 'neutral'

type StatusBadgeClasses = { bg: string; text: string }

const variantMap: Record<StatusLevel, StatusBadgeClasses> = {
    critical: { bg: 'bg-status-muted-critical', text: 'text-status-critical' },
    caution: { bg: 'bg-status-muted-caution', text: 'text-status-caution' },
    warning: { bg: 'bg-status-muted-warning', text: 'text-status-warning' },
    success: { bg: 'bg-status-muted-success', text: 'text-status-success' },
    info: { bg: 'bg-status-muted-info', text: 'text-status-info' },
    neutral: { bg: 'bg-status-muted-neutral', text: 'text-status-neutral' },
}

export function statusBadgeVariants(status: StatusLevel): StatusBadgeClasses {
    return variantMap[status]
}
